@if (editMode) {
  <div class="paragraph-edit-wrapper">
    <div class="paragraph-toolbar">
      <button mat-icon-button color="warn" (click)="deleteParagraph()" aria-label="Delete paragraph" matTooltip="Delete paragraph">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
    <quill-editor
      [theme]="'snow'"
      [formControl]="contentControl"
      (onContentChanged)="onEditorChange($event)"
      (onBlur)="commitEditor()"
    ></quill-editor>
  </div>
} @else {
  <div class="paragraph-display-wrapper">
    <div class="paragraph-display" [innerHTML]="trustedHtml"></div>
    @if (canShowParagraphButton) {
      <button
        mat-mini-fab
        color="accent"
        class="paragraph-comment-btn mat-elevation-z2 z2-elevation"
        (click)="openParagraphCommentDialog()"
        matTooltip="Add comment"
        aria-label="Add comment"
      >
        <mat-icon>add_comment</mat-icon>
      </button>
    }
    @if (canShowSelectionButton) {
      <button
        mat-mini-fab
        color="accent"
        class="selection-comment-btn mat-elevation-z2 z2-elevation"
        (click)="openSelectionCommentDialog()"
        [ngStyle]="{ top: selectionButtonPosition.top + 'px', left: selectionButtonPosition.left + 'px' }"
        matTooltip="Comment selection"
        aria-label="Add comment for selection"
      >
        <mat-icon>add_comment</mat-icon>
      </button>
    }
  </div>
}
@if (documentNode.comments?.length > 0) {
  @for (comment of documentNode.comments; track comment) {
    <app-comment-rail [nodeId]="documentNode?.id" [reviewerMode]="false" [comment]="comment"></app-comment-rail>
  }
}

@if (documentNode.children?.length) {
  <div>
    @for (child of documentNode.children; track child) {
      <div>
        <ng-container
          *ngComponentOutlet="
            nodeFactory.getComponentForNodeType(child.type);
            injector: nodeFactory.createInjector(child, procedureDocument, injector)
          "
        ></ng-container>
      </div>
    }
  </div>
}
